const NoDataMessage = ({ children, center, style }) => (
  <div className={`no-data${center ? " center" : ""}`} style={style}>
    {children}
  </div>
);

export default NoDataMessage;
